import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import countdown from "../../../Assets/Images/countDown.png";
import messengerLock from "../../../Assets/Images/lockMessnger.png";
import lockTwo from "../../../Assets/Images/lockTwo.png";
import "./ChatHead.css";

const ChatHead = ({ openMessenger, setOpenMessenger, data }) => {
  const [play, setPlay] = useState(0);
  // const [openMessenger, setOpenMessenger] = React.useState(false);

  const [chatInfo, setChatInfo] = useState([]);
  const [starInfo, setStarInfo] = useState([]);
  const [qnaSessionRoom, setQnaSessionRoom] = useState("");

  useEffect(() => {
    axios.get(`api/user/sinlgeQna/${data}`).then((res) => {
      if (res.data.status === 200) {
        setChatInfo(res.data.liveChat);
        setStarInfo(res.data.starInfo);
      }
    });
    axios.get(`api/user/qna/reg_info/${data}`).then((res) => {
      if (res.data.status === 200) {
        setQnaSessionRoom(res.data.event);
      }
    });
  }, []);
  const event_start_time =
    moment(chatInfo?.event_date).format("LL") +
    " " +
    qnaSessionRoom?.qna_start_time;
  const event_end_time =
    moment(chatInfo?.event_date).format("LL") +
    " " +
    qnaSessionRoom?.qna_end_time;

  const event_start = new Date(event_start_time).getTime();
  const event_end = new Date(event_end_time).getTime();

  const [day, setDay] = useState("");
  const [hour, setHour] = useState("");
  const [minute, setMinute] = useState("");
  const [second, setSecond] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = event_start - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      setDay(days);

      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      setHour(hours);

      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      setMinute(minutes);

      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      setSecond(seconds);
    });

    return () => clearInterval(interval);
  }, [event_start]);

  return (
    <>
      <div className="messenger-menu">
        <div className="d-flex navBg">
          <i className="fa-solid fa-arrow-left-long backArrow flexBackArrow mt-1"></i>
          <h6 className="text-light fw-bold flexName px-2">
            {starInfo?.first_name} {starInfo?.last_name}
          </h6>
          <i className="fas fa-ellipsis-v backArrow flexBackArrow"></i>
          <i className="fa-solid fa-minus backArrow flexBackArrow"></i>
          <i
            onClick={() => setOpenMessenger(0)}
            className="fa-solid fa-xmark backArrow flexBackArrow"
          ></i>
        </div>
        <div className="messengerLockDiv">
          <img src={messengerLock} alt="" className="messenger-lock-img" />

          <div className="positionDiv d-flex flex-column justify-content-around">
            <div className="d-flex justify-content-center w-100">
              <img className="img-fluid mt-5" src={lockTwo} alt="" />
            </div>
            <div className="d-flex justify-content-center w-100 countDownDiv">
              <img className="img-fluid mb-5" src={countdown} alt="" />
              <div className="d-flex flex-column countDownDivAbs">
                <span className="timeLeftTime text-center">
                  {event_end > new Date().getTime() ? (
                    <>
                      {day}:{hour}:{minute}:{second}
                    </>
                  ) : (
                    <>00:00:00:00</>
                  )}
                </span>
                <span className="timeLeftTime text-center">Left</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatHead;
